export default {
  acknowledge: 'Beru na vědomí',
  expand: 'Zobrazit více',

  Banner: {
    'unit-multiple-owners': {
      title: 'Jednotky s více spoluvlastníky',
      intro_one: 'Vaše SVJ má 1 jednotku s více spoluvlastníky.',
      intro_few: 'Vaše SVJ má {{count}} jednotky s více spoluvlastníky.',
      intro_other: 'Vaše SVJ má {{count}} jednotek s více spoluvlastníky.',
      text:
        'Ve výchozím nastavení hlasuje za celý podíl jednotky ten ze spoluvlastníků, kdo odhlasuje první. U manželů (SJM) může hlasovat kterýkoli z nich, písemný souhlas druhého se nevyžaduje. Ostatním spoluvlastníkům doporučujeme zvolit si společného zástupce — stačí většina podle velikosti podílů (§ 1128 občanského zákoníku).',
      hint: 'Zástupce nastavíte v detailu jednotky volbou typu hlasování „Společný zástupce" — hlasovat za jednotku pak bude moci pouze on (od ostatních spoluvlastníků, vyjma případu SJM, je potřeba mít souhlas).',
    },

    'garage-with-quorum': {
      title: 'Garáž s odděleným hlasováním',
      intro_one: 'Vaše SVJ má společnou garáž s více spoluvlastníky.',
      intro_few: 'Vaše SVJ má {{count}} společné garáže s více spoluvlastníky.',
      intro_other: 'Vaše SVJ má {{count}} společných garáží s více spoluvlastníky.',
      text:
        'Takovým garážím automaticky nastavujeme způsob vyhodnocení „Oddělené hlasování" — spoluvlastníci hlasují uvnitř jednotky a výsledný hlas garáže se přičte podle jejího podílu na domě. Jediný způsob hlasování s jasnou oporou v zákoně je ale volba společného zástupce, který za celou jednotku hlasuje vůči SVJ (§ 1185 odst. 2 občanského zákoníku).',
      hint: 'Pokud garáž zvoleného zástupce má, nastavte jej v detailu jednotky — hlasovat za ni pak bude moci pouze on.',
    },
  },
};
